export type NativeNoticeType = "success" | "error" | "info";

export const notify = (message: string, type: NativeNoticeType = "info") => {
  if (typeof window === "undefined") {
    console[type === "error" ? "error" : "info"](message);
    return;
  }
  window.dispatchEvent(
    new CustomEvent("native-notice", { detail: { type, message } }),
  );
};
